module.exports = __webpack_public_path__ + "img/Girl_030033.09edc41f.png";